import AddIcon from '@mui/icons-material/Add';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsButton, WsTitleBanner } from 'wisestep-base';

import { ActivateFeature } from '../../../../components/ActivateFeature';

const ConsultantHeader = () => {
  const navigate = useNavigate();

  return (
    <WsTitleBanner
      title="Consultants"
      goBack={() => navigate('/home')}
      rightChildren={
        <Stack width="40%" justifyContent="right" direction="row" spacing={2}>
          <WsButton
            size="small"
            onClick={() => navigate('/vendors/new-vendor-list')}
            startIcon={<AddIcon />}
          >
            Add or Import Vendors
          </WsButton>
          <ActivateFeature feature="CL_ADD_AND_IMPORT">
            <WsButton
              size="small"
              variant="contained"
              onClick={() => navigate('/consultant/uploads')}
              startIcon={<AddIcon />}
            >
              Add Consultant
            </WsButton>
          </ActivateFeature>
        </Stack>
      }
    />
  );
};

export default ConsultantHeader;
